import React, { useState } from 'react';
import { useDeleteSite } from '../hooks/useSites';

interface BulkDeleteSitesModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedSites: any[];
  onSuccess: () => void;
}

const BulkDeleteSitesModal: React.FC<BulkDeleteSitesModalProps> = ({
  isOpen,
  onClose,
  selectedSites,
  onSuccess
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const deleteSite = useDeleteSite();

  const handleDelete = async () => {
    setIsLoading(true);

    try {
      const deletePromises = selectedSites.map(site => 
        deleteSite.mutateAsync(site.id)
      );

      await Promise.all(deletePromises);
      onSuccess();
      onClose();
    } catch (error) {
      console.error('Erreur lors de la suppression en masse:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <h2 className="text-lg font-semibold mb-4 text-red-600">
          Supprimer {selectedSites.length} site{selectedSites.length > 1 ? 's' : ''}
        </h2>

        <div className="mb-6">
          <p className="text-gray-700 mb-4">
            Êtes-vous sûr de vouloir supprimer {selectedSites.length} site{selectedSites.length > 1 ? 's' : ''} ?
          </p>
          
          <div className="bg-red-50 border border-red-200 rounded-md p-3">
            <p className="text-sm text-red-800">
              ⚠️ <strong>Attention :</strong> Cette action supprimera également tous les bâtiments, 
              pièces, zones et objets associés à ces sites.
            </p>
          </div>

          <div className="mt-3">
            <p className="text-sm font-medium text-gray-700 mb-2">Sites à supprimer :</p>
            <ul className="text-sm text-gray-600 max-h-32 overflow-y-auto">
              {selectedSites.map(site => (
                <li key={site.id} className="py-1">• {site.nom}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition-colors"
          >
            Annuler
          </button>
          <button
            onClick={handleDelete}
            disabled={isLoading}
            className="flex-1 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 disabled:opacity-50 transition-colors"
          >
            {isLoading ? 'Suppression...' : 'Supprimer'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkDeleteSitesModal;
